<script setup>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useAuth } from "@/composables/useAuth"; // 👈 IMPORTANTE

import Sidenav from "./quote/Sidenav";
import Navbar from "@/quote/Navbars/Navbar.vue";
import AppFooter from "@/quote/Footer.vue";

const store = useStore();
const { user, loadUser, vigilarSesion } = useAuth(); // 👈

const isNavFixed = computed(() => store.state.isNavFixed);
const darkMode = computed(() => store.state.darkMode);
const isAbsolute = computed(() => store.state.isAbsolute);
const showSidenav = computed(() => store.state.showSidenav);
const layout = computed(() => store.state.layout);
const showNavbar = computed(() => store.state.showNavbar);
const showFooter = computed(() => store.state.showFooter);
const mobileSidenavOpen = computed(() => store.state.mobileSidenavOpen);
const cerrarSidenavMobile = () => store.commit("closeMobileSidenav");

const navClasses = computed(() => {
  return {
    "position-sticky bg-white left-auto top-2 z-index-sticky":
      isNavFixed.value && !darkMode.value,
    "position-sticky bg-default left-auto top-2 z-index-sticky":
      isNavFixed.value && darkMode.value,
    "position-absolute px-4 mx-0 w-100 z-index-2": isAbsolute.value,
    "px-0 mx-4": !isAbsolute.value,
  };
});

// 👇 AÑADE ESTO
onMounted(async () => {
  if (!user.value) {
    await loadUser();
  }
  vigilarSesion();
});
</script>
<template>
  <div v-show="layout === 'landing'" class="landing-bg h-100 bg-gradient-primary position-fixed w-100"></div>

  <sidenav v-if="showSidenav" />

  <!-- Fondo oscuro detrás del sidenav cuando está abierto en mobile/tablet
       (<1200px): permite cerrarlo tocando afuera, patrón estándar de un
       menú lateral off-canvas. La media query lo deja inerte en escritorio
       aunque el estado quedara en true por error. -->
  <div
    v-if="showSidenav && mobileSidenavOpen"
    class="mobile-sidenav-backdrop"
    @click="cerrarSidenavMobile"
  ></div>

  <main class="main-content position-relative max-height-vh-100 h-100 border-radius-lg d-flex flex-column min-vh-100">
    <!-- nav -->

    <navbar :class="[navClasses]" v-if="showNavbar" />

    <router-view />

    <app-footer v-show="showFooter" />

  </main>
</template>

<style scoped>
.mobile-sidenav-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  /* El tema define ".sidenav{z-index:999}" pero una regla de Bootstrap con
     la misma especificidad (".navbar-vertical.navbar-expand-xs{z-index:1030}")
     la pisa por venir después en la hoja compilada, así que el z-index
     real del sidenav termina siendo 1030, no 9999. El backdrop tiene que
     quedar por debajo de eso o tapa el propio menú e impide interactuar
     con él. */
  z-index: 1029;
}

@media (min-width: 1200px) {
  .mobile-sidenav-backdrop {
    display: none;
  }
}
</style>
